import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { translate } from '@jsverse/transloco';

import { dashboardPageNameValidatorFactory } from 'app/modules/configuration/configuration-utils';
import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';

import { ErrorObjectUtils } from 'app/utils/error-object.utils';
import { DashboardPage } from './../../../../providers/bridge-api/dashboard.service';

export interface DashboardPageRenameDialogOptions {
  currentPage: DashboardPage;
  pages: DashboardPage[];
}

@EnableClassTelemetry()
@Component({
  selector: 'app-dashboard-page-rename-dialog',
  templateUrl: './dashboard-page-rename-dialog.component.html',
  styleUrls: ['./dashboard-page-rename-dialog.component.scss'],
  standalone: false,
})
export class DashboardPageRenameDialogComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  @Input() options: DashboardPageRenameDialogOptions;

  @Output() modalClosed = new EventEmitter<string>();

  pageName: string;
  pageNameValidator;
  pageNameStatus = ErrorObjectUtils.create();

  constructor() {}

  ngOnInit(): void {
    this.pageName = this.options.currentPage.title;
    this.pageNameValidator = dashboardPageNameValidatorFactory(
      this.options.pages,
      this.options.currentPage
    );
  }

  onValidatePageName() {
    const validationStatus = this.pageNameValidator({ value: this.pageName });
    ErrorObjectUtils.setSuccess(this.pageNameStatus);
    if (validationStatus?.minLength) {
      ErrorObjectUtils.setError(
        this.pageNameStatus,
        translate('dashboard-page-rename-dialog-component.too-short', {
          minLength: validationStatus.minLength.minLength,
        })
      );
    } else if (validationStatus?.maxLength) {
      ErrorObjectUtils.setError(
        this.pageNameStatus,
        translate('dashboard-page-rename-dialog-component.too-long', {
          maxLength: validationStatus.maxLength.maxLength,
        })
      );
    } else if (validationStatus?.nameAlreadyExists) {
      ErrorObjectUtils.setError(
        this.pageNameStatus,
        translate('dashboard-page-rename-dialog-component.name-exists')
      );
    }
  }

  get isValid() {
    return (
      this.pageNameStatus.state === 'success' && this.pageName !== this.options.currentPage.title
    );
  }

  cancel() {
    this.modalClosed.emit();
  }

  save() {
    this.modalClosed.emit(this.pageName);
  }
}
